/**
 * News Dashboard
 */

import React, { Component } from 'react'
import Content from './content';
import InstructionVideoLecture from "./InstructionVideoLecture";
import {Dialog} from "@mui/material";
import {withStyles} from "tss-react/mui";
import InstructionLBLT from "./InstructionLBLT";

const instruction = ({isOpen, onClose, theme, type, video}) => {
    if(type === undefined || type === null || type === 'null') return null;

    const renderContent = () => {
        switch (type) {
            case 'VIDEO-LECTURE':
                return <InstructionVideoLecture onClose={onClose} theme={theme} type={type} video={video}/>;
            case 'LBLT':
                return <InstructionLBLT onClose={onClose} theme={theme} type={type} video={video}/>;
            default:
                return <Content onClose={onClose} theme={theme} type={type} video={video}/>;
        }
    };

    return (
        <FullDialog open={isOpen} onClose={onClose} aria-labelledby="alert-dialog-title" maxWidth='md' fullWidth style={{container: {height: '80%'}}}>
            {
                renderContent()
            }
        </FullDialog>
    )
}

export default instruction;

const FullDialog = withStyles(Dialog, (theme) => ({
    paper: {
        height: '100%',
        maxWidth: 1090
    }
}));
